import axiox from 'axios'
import {baseURL} from './config'
export const httpCall=({url,headers,data,method})=>axiox({
  method:method||'POST',
  url: baseURL+url,
  data,
  headers
})